<div>
	<form [formGroup]="form">
		<div class="mb-3 row">
			<div class="col-md-6">
				<div class="mb-3 row" [ngClass]="{'has-error':!showMap.valid}">
					<div class="uv-row">
						<input type="checkbox" id="layoutShowMap" [formControl]="showMap" />
						<span class="uv-checkbox-label">Show Map</span>
					</div>
				</div>
				<div class="mb-3 row" [ngClass]="{'has-error':!drawLinkLabels.valid}">
					<div class="uv-row">
						<input type="checkbox" id="layoutDrawLinkLabels" [formControl]="drawLinkLabels" />
						<span class="uv-checkbox-label">Draw Link Labels</span>
					</div>
				</div>
				<div class="mb-3 row" [ngClass]="{'has-error':!includePhysicalLinks.valid}">
					<div class="uv-row">
						<input type="checkbox" id="layoutIncludePhysicalLinks" [formControl]="includePhysicalLinks" />
						<span class="uv-checkbox-label">Include Physical Links</span>
					</div>
				</div>
				<div class="mb-3 row" [ngClass]="{'has-error':!includeAssociatedLinks.valid}">
					<div class="uv-row">
						<span style="margin-right:10px;">Include Associated Links: </span>
						<p-multiSelect class="link-select" [options]="associatedLinksOptions" [filter]="false" formControlName="includeAssociatedLinks"></p-multiSelect>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="mb-3 row" [ngClass]="{'has-error':!showChildGroups.valid}">
					<div class="uv-row">
						<input type="checkbox" id="layoutShowChildGroups" [formControl]="showChildGroups" (change)="onShowChildGroupsChange()"/>
						<span class="uv-checkbox-label">Show Child Groups</span>
					</div>
				</div>
				<div class="mb-3 row" [ngClass]="{'has-error':!showChildDevices.valid}">
					<div class="uv-row">
						<input type="checkbox" id="layoutShowChildDevices" [formControl]="showChildDevices" [disabled]="!showChildGroups.value"/>
						<span class="uv-checkbox-label">Show Child Group Devices</span>
					</div>
				</div>
			</div>
		</div>

			<layout-settings [target]="target?.DeviceGroup.Map.LayoutSettings"
							 [allowManualLayout]="true"></layout-settings>

</form>
</div>
